export default __webpack_public_path__ + "alberta-accounting-month.59b9b9faeb951d53f572.svg";